import { render, staticRenderFns } from "./companypages.vue?vue&type=template&id=224d395c&scoped=true&"
import script from "./companypages.vue?vue&type=script&lang=js&"
export * from "./companypages.vue?vue&type=script&lang=js&"
import style0 from "./companypages.vue?vue&type=style&index=0&id=224d395c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224d395c",
  null
  
)

export default component.exports